import { PropertySubTypeDTO } from "../DTO/propertySubTypeDTO";

export class PropertySubType{
    
    public id!:number;
    public name!:string;
    
    constructor(){
    }

    public static mapToDTO(param:PropertySubType) : PropertySubTypeDTO{
        
        let dto = new PropertySubTypeDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:PropertySubTypeDTO) : PropertySubType
    {
        
        let obj = new PropertySubType();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
}